import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ApiConfig from "../../../api/ApiConfig";
import { multipartPostCallWithErrorResponse, postRequest, postWithAuthCall, simpleGetCallWithToken, simplePostCall } from "../../../api/ApiServices";
import { ToastMsg } from "../../TostMsg";
import { AppContext } from "../../../context/AppContext";

const EditCase = () => {
  const { sidebar, editKewordDtls, selectedDomainId, setEditKeyWordDtls,intentAndKeywords,  } = useContext(AppContext);
  const navigate = useNavigate();

  const [dropwDownOptions, setDropDownOptions] = useState({
    intents: []
  })

console.log("intentAndKeywords",intentAndKeywords);

  const [EditCase, setEditCase] = useState({
    // TeamId: "",
    test_case_code_id: "",
    TeamHead: "",
    DepartmentId: "",
    PhotoPath: "",
    Intent: "",
    PredecessorTestCase: "",
    SuccessorTestCase: "",
    TestCaseID: "",
    TestCaseType: "",
    TestModule: "",
    TestSubModule: "",
    TestKeyFeatures: "",
    PreConditions: "",
    TestSteps: "",
    TestData: "",
    TestCaseDescription: "",
    ExpectedResults: "",
    ActualResults: "",
    PostConditions: "",
    PassFailCriteria: "Pass", // Default value
  });

  useEffect(() => {
    // debugger
    if (intentAndKeywords.length > 0) {
        setEditCase(prevState => ({
            ...prevState,
            Intent: intentAndKeywords[0]?.intent || ""
        }));
    }
}, [intentAndKeywords]); // Runs when intentAndKeywords changes



console.log("EditCase",EditCase);







  const UpdateApi = () => {
    if (!EditCase.Intent || !EditCase.TestModule) {
      ToastMsg("error", "Please fill in all required fields.");
      return;
    }

    const body = {
      // team_id: EditCase.TeamId,
      // team_name: EditCase.TeamName,
      domain_id: selectedDomainId,
      team_head: EditCase.TeamHead,
      department_id: EditCase.DepartmentId,
      PhotoPath: EditCase.PhotoPath,
      intent: EditCase.Intent,
      predecessor_test_case: EditCase.PredecessorTestCase,
      successor_test_case: EditCase.SuccessorTestCase,
      test_case_type: EditCase.TestCaseType,
      test_module: EditCase.TestModule,
      test_sub_module: EditCase.TestSubModule,
      test_key_features: EditCase.TestKeyFeatures,
      pre_conditions: EditCase.PreConditions,
      test_steps: EditCase.TestSteps,
      test_data: EditCase.TestData,
      test_case_description: EditCase.TestCaseDescription,
      expected_results: EditCase.ExpectedResults,
      actual_results: EditCase.ActualResults,
      post_conditions: EditCase.PostConditions,
      pass_fail_criteria: EditCase.PassFailCriteria,
      test_case_id: editKewordDtls,
      test_case_code_id: EditCase.TestCaseID
    };

    let apiUrl = editKewordDtls ? ApiConfig.TEST_CASE_UPDATE : ApiConfig.TEST_CASE_ADD;
    postRequest(apiUrl, JSON.stringify(body))
      .then((res) => {
        console.log("res", res);

        if (res?.success === true) {
          ToastMsg("success", res?.message);
          navigate("/testCases");
        } else {
          ToastMsg("error", res?.message || "Update failed.");
          console.log("Error Response:", res);
        }
      })
      .catch((err) => {
        console.log("API Update Error:", err);
      });
  };


  const getIntentDropDown = () => {

    simpleGetCallWithToken(ApiConfig?.GET_INTENT_DROPDOWN + selectedDomainId).then((res) => {

      if (res?.success) {
        setDropDownOptions(prev => ({
          ...prev,
          intents: res?.data
        }))
      }

    })

  }

  useEffect(() => {
    if (!editKewordDtls) {

      getIntentDropDown()

      return

    }; // Prevent API call if editKewordDtls is missing

    simpleGetCallWithToken(ApiConfig.TEST_CASE_GET + editKewordDtls)
      .then((res) => {
        console.log("API Response:", res); // Debugging


        const apiData = res.data; // Get first test case if response is an array
        console.log("apiData:", apiData); // Debugging

        setEditCase({
          // TeamId: apiData.team_id || "",
          // TeamName: apiData.team_name || "",
          TeamHead: apiData.team_head || "",
          DepartmentId: apiData.department_id || "",
          PhotoPath: apiData.photo_path || "",
          Intent: apiData.intent || "",
          PredecessorTestCase: apiData.predecessor_test_case || "",
          SuccessorTestCase: apiData.successor_test_case || "",
          TestCaseID: apiData.test_case_code_id || "",
          TestCaseType: apiData.test_case_type || "",
          TestModule: apiData.test_module || "",
          TestSubModule: apiData.test_sub_module || "",
          TestKeyFeatures: apiData.test_key_features || "",
          PreConditions: apiData.pre_conditions || "",
          TestSteps: apiData.test_steps || "",
          TestData: apiData.test_data || "",
          TestCaseDescription: apiData.test_case_description || "",
          ExpectedResults: apiData.expected_results || "",
          ActualResults: apiData.actual_results || "",
          PostConditions: apiData.post_conditions || "",
          PassFailCriteria: apiData.pass_fail_criteria || "Pass", // Default "Pass"
        });

        console.log("Updated EditCase:", EditCase); // Debugging

      })
      .catch((err) => {
        console.log("API Fetch Error:", err);
      });
    return () => {
      setEditKeyWordDtls(null)
    }
  }, [editKewordDtls]); // Re-run when editKewordDtls changes


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditCase({ ...EditCase, [name]: value });
  };

  return (
    <>
      <div className={sidebar ? "taskMain" : "cx-active taskMain"} id="cx-main">
        <div className="role-content">
          <div className="sub-header-role">
            <h6 className="mt-2">Edit Case</h6>
          </div>
          <div className="createCard">
            <div className="row">
              {[
                // { label: "Team Name", name: "TeamName", type: "input" },
                { label: "Intent", name: "Intent", type: editKewordDtls ? "input" : 'select', key: 'intent', list: 'intents' },
                { label: "Predecessor Test Case", name: "PredecessorTestCase", type: "input" },
                { label: "Successor Test Case", name: "SuccessorTestCase", type: "input" },
                { label: "Test Case ID", name: "TestCaseID", type: "input" },
                { label: "Test Case Type", name: "TestCaseType", type: "input" },
                { label: "Test Module", name: "TestModule", type: "input" },
                { label: "Test Sub Module", name: "TestSubModule", type: "input" },
                { label: "Test Key Features", name: "TestKeyFeatures", type: "input" },
                { label: "Pre-Conditions", name: "PreConditions", type: "textarea" },
                { label: "Test Steps", name: "TestSteps", type: "textarea" },
                { label: "Test Data", name: "TestData", type: "textarea" },
                { label: "Test Case Description", name: "TestCaseDescription", type: "textarea" },
                { label: "Expected Results", name: "ExpectedResults", type: "textarea" },
                { label: "Actual Results", name: "ActualResults", type: "input" },
                { label: "Post Conditions", name: "PostConditions", type: "input" },
              ].map((field, index) => (
                <div key={index} className="col-md-12 col-lg-6">
                  <div className="modalProp mb-4">
                    <label htmlFor={field.name} className="enter-role-text mt-2" style={{ fontSize: "12.8px" }}>
                      {field.label}
                    </label>
                    {field.type === "textarea" ? (
                      <textarea
                        onChange={handleInputChange}
                        value={EditCase[field.name]}
                        name={field.name}
                        placeholder={`Enter ${field.label}`}
                        className="date-label-input tasKCategory1 focusBlc"
                        style={{
                          fontSize: "14px",
                          height: "80px",
                          border: "1px solid #ced4da",
                          padding: "8px",
                          resize: "vertical",
                        }}
                      />
                    ) : (
                      field?.type == 'select' ?

                        <select
                          onChange={handleInputChange}
                          value={EditCase[field.name]}
                          name={field.name}
                          className="date-label-input tasKCategory1 focusBlc"
                          style={{
                            fontSize: "14px",
                            height: "38px",
                            border: "1px solid #ced4da",
                            padding: "6px",
                          }}
                        >
                          {
                            dropwDownOptions[field?.list]?.map((i, index) => {
                              return <option key={index} value={i?.intent}>{i[field?.key]}</option>
                            })
                          }

                        </select>

                        :
                        <input
                          maxLength="100"
                          onChange={handleInputChange}
                          value={EditCase[field.name]}
                          name={field.name}
                          type="text"
                          placeholder={`Enter ${field.label}`}
                          className="date-label-input tasKCategory1 focusBlc"
                          style={{
                            fontSize: "14px",
                            height: "38px",
                            border: "1px solid #ced4da",
                          }}
                        />
                    )}
                  </div>
                </div>
              ))}

              {/* Pass/Fail Criteria Dropdown */}
              <div className="col-md-12 col-lg-6">
                <div className="modalProp mb-4">
                  <label htmlFor="PassFailCriteria" className="enter-role-text mt-2" style={{ fontSize: "12.8px" }}>
                    Pass/Fail Criteria
                  </label>
                  <select
                    onChange={handleInputChange}
                    value={EditCase.PassFailCriteria}
                    name="PassFailCriteria"
                    className="date-label-input tasKCategory1 focusBlc"
                    style={{
                      fontSize: "14px",
                      height: "38px",
                      border: "1px solid #ced4da",
                      padding: "6px",
                    }}
                  >
                    <option value="Pass">Pass</option>
                    <option value="Fail">Fail</option>
                    <option value="Conditional Pass">Conditional Pass</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <button className="modal-create-btn" onClick={UpdateApi}>
                  {editKewordDtls ? "Update" : "Add"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditCase;
